import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SignalPositionDetails from './SignalPositionDetails';
import HedgePositionDetails from './HedgePositionDetails';
import './PositionDetails.css';
import { buildScopedApiUrl, ensureArray, getApiHeaders } from "./config";
import ManualHedge from './ManualHedge';
import SignalDCA from './SignalDCA';
import SignalPartialTakeProfit from './SignalPartialTakeProfit';
import HedgePartialTakeProfit from './HedgePartialTakeProfit';
import HedgeOffsetLevelDetails from './HedgeOffsetLevel/HedgeOffsetLevelDetails';
import SpecialConfigurationDetails from './Specialconfiguration/SpecialConfigurationDetails';
import SignalResistanceLevel from './SignalResistanceLevel';
import HedgeResistanceLevel from './HedgeResistanceLevel';
import RepelTradeHedgeCloserModal from './RepelTradeHedgeCloserModal';

import HedgeToSignalConversionModal from './HedgeToSignalConversionModal';
import { useWorkspace } from './workspace/WorkspaceContext';

function PositionDetails({ symbol }) {
  const { workspace } = useWorkspace();
  const [signalRequests, setSignalRequests] = useState([]);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
  
    const [actionSymbol, setActionSymbol] = useState(null);
    const [isManualHedgeModalOpen, setIsManualHedgeModalOpen] = useState(false);
    const [isSignalDCAModalOpen, setIsSignalDCAModalOpen] = useState(false);
  
    const [isSignalTPModalOpen, setIsSignalTPModalOpen] = useState(false);
    const [isHedgeTPModalOpen, setIsHedgeTPModalOpen] = useState(false);
    const [isSignalResistanceLevelModalOpen, setIsSignalResistanceLevelModalOpen] = useState(false);
    const [isHedgeResistanceLevelModalOpen, setIsHedgeResistanceLevelModalOpen] = useState(false);
    const [signalPositionrefreshTrigger, setSignalPositionrefreshTrigger] = useState(0);
    const [hedgePositionrefreshTrigger, setHedgePositionrefreshTrigger] = useState(0);
  
    const [isRepelTradeHedgeCloserModalOpen, setIsRepelTradeHedgeCloserModalOpen] = useState(false);
    const [isHedgeToSignalConvertModalOpen, setIsHedgeToSignalConvertModalOpen] = useState(false);
  
    const navigate = useNavigate();
  
  
    useEffect(() => {
      const intervalId = setInterval(() => {
        setRefreshTrigger(prev => prev + 1); // Increment the trigger to cause a re-render
      }, 10000); // 10 seconds
    
      return () => clearInterval(intervalId); // Clear interval on component unmount
    }, []);

 

  const handleModalComponentSelect = (componentName,actionSymbol) => {
    if (componentName === 'ManualHedge' ) {
      setIsManualHedgeModalOpen(true);
      setActionSymbol(actionSymbol);
    } else if ( componentName === 'SignalDCA' ) {
      setIsSignalDCAModalOpen(true);
      setActionSymbol(actionSymbol);
    } else if ( componentName === 'SignalPartialTakeProfit' ) {
      setIsSignalTPModalOpen(true);
      setActionSymbol(actionSymbol);
    }  else if ( componentName === 'HedgePartialTakeProfit' ) {
      setIsHedgeTPModalOpen(true);
      setActionSymbol(actionSymbol);
    }  else if ( componentName === 'SignalResistanceLevel' ) {
      setIsSignalResistanceLevelModalOpen(true);
      setActionSymbol(actionSymbol);
    }  else if ( componentName === 'HedgeResistanceLevel' ) {
      setIsHedgeResistanceLevelModalOpen(true);
      setActionSymbol(actionSymbol);
    } else if ( componentName === 'RepelTradeHedgeCloser' ) {
      setIsRepelTradeHedgeCloserModalOpen(true);
      setActionSymbol(actionSymbol);
    } else if ( componentName === 'HedgeToSignalCovert' ) {
      setIsHedgeToSignalConvertModalOpen(true);
      setActionSymbol(actionSymbol);
    }        
  };

  const closeSignalDCAModal = () => {
    setIsSignalDCAModalOpen(false);
    setSignalPositionrefreshTrigger(prev => prev + 1);
  };

  const closeSignalTPModal = () => {
    setIsSignalTPModalOpen(false);
    setSignalPositionrefreshTrigger(prev => prev + 1);
  };


  const closeSignalResistanceLevelModal = () => {
    setIsSignalResistanceLevelModalOpen(false);
    setSignalPositionrefreshTrigger(prev => prev + 1);
  };


  const closeManualHedgeModal = () => {
    setIsManualHedgeModalOpen(false);
    setHedgePositionrefreshTrigger(prev => prev + 1 );
  };


  const closeHedgeTPModal = () => {
    setIsHedgeTPModalOpen(false);
    setHedgePositionrefreshTrigger(prev => prev + 1 );
  };

  const closeRepelTradeHedgeCloserModal = () => {
    setIsRepelTradeHedgeCloserModalOpen(false);
  };

  const closeHedgeToSignalConvertModal = () => {
    setIsHedgeToSignalConvertModalOpen(false);
  };


  const closeHedgeResistanceLevelModal = () => {
    setIsHedgeResistanceLevelModalOpen(false);    
    setHedgePositionrefreshTrigger(prev => prev + 1 );
  };


  useEffect(() => {
    const intervalId = setInterval(() => {
      setRefreshTrigger(prev => prev + 1);
    }, 10000);
    return () => clearInterval(intervalId);
  }, []);


useEffect(() => {
    const fetchSignalRequests = async () => {
      try {
        setLoading(true);
        const response = await fetch(buildScopedApiUrl('/api/bot/ui/get/getSignalRequests', workspace),
          {
            headers: getApiHeaders()
          })
        if (!response.ok) throw new Error('Failed to fetch signal requests');

        const data = await response.json();
        const normalizedRequests = ensureArray(data);

        console.log('Fetched Data:', data); // Debugging

        // If symbol is provided, filter results; otherwise, show all
        const filteredData = symbol
          ? normalizedRequests.filter(request => request.symbol.toUpperCase() === symbol.toUpperCase())
          : normalizedRequests;

        console.log('Filtered Data:', filteredData); // Debugging

        setSignalRequests(filteredData);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSignalRequests();
  }, [symbol, workspace]);


  return (

    <div className="position-details-container">
    <h2 className="page-title">{symbol ? `Position Details for ${symbol}` : "All Active Positions"}</h2>
      {signalRequests && (
                <div>
                  <div >                                        
                    <button className="back-button" onClick={() => navigate('/')}>
                        Back to Main Screen
                    </button>                    
                  </div>
                
                  {loading && <p className="loading-message">Loading...</p>}
                  {error && <p>Error: {error}</p>}
               {signalRequests.length > 0 ? (signalRequests.map((signalRequest, index) => (
                  <div key={index} className="symbol-section">
                    <h3 style={{ color: '#FFFFFF', backgroundColor: '#000000', padding: '10px' }}>
                    {signalRequest.symbol}
                    {signalRequest.repelTrade === 'true' ? '  -  Repel Trade ' : signalRequest.repelTrade === 'lateRepel' ? '  - Mid Repel Trade ' : ''}                    
                    </h3>
                    <br/>
                    <h2 className="page-title">Signal Position</h2>
                    <SignalPositionDetails
                      signalRequestId={signalRequest.signalRequestId}
                      symbol={signalRequest.symbol}
                      side={signalRequest.side}
                      refreshTrigger={refreshTrigger}
                      signalPositionrefreshTrigger={signalPositionrefreshTrigger}
                    />                       
                    <br/>
                    <div className="button-container"> 
                      <button onClick={() => handleModalComponentSelect('SignalPartialTakeProfit', signalRequest)}>Signal Partial TakeProfit</button> <span/>                   
                      <button onClick={() => handleModalComponentSelect('SignalDCA', signalRequest)}>Signal DCA</button>      <span/>  
                      <button onClick={() => handleModalComponentSelect('SignalResistanceLevel', signalRequest)}>Signal Resistance Levels</button>
                      <button
              onClick={() => {
                sessionStorage.setItem('previousPath', window.location.pathname);
                navigate(`/app/${workspace.exchange}/${workspace.marketType}/order-history/${signalRequest.signalRequestId}`);
              }}
            >
              View Order History
            </button>
                    </div>
                    <br/>
                    <br/>
                    <h2 className="page-title">Hedge Position</h2>        
                    <HedgePositionDetails
                      signalRequestId={signalRequest.signalRequestId}
                      symbol={signalRequest.symbol}
                      side={signalRequest.side}
                      refreshTrigger={refreshTrigger}
                      hedgePositionrefreshTrigger={hedgePositionrefreshTrigger}
                    />
                    <br/>
                    <div className="button-container"> 
                      <button onClick={() => handleModalComponentSelect('HedgePartialTakeProfit', signalRequest)}>Hedge Partial TakeProfit</button> <span/>                                 
                      <button onClick={() => handleModalComponentSelect('ManualHedge', signalRequest)}>Manual Hedge</button>  <span/>                
                      <button onClick={() => handleModalComponentSelect('HedgeResistanceLevel', signalRequest)}>Hedge Resistance Levels</button> 
                      <button onClick={() => handleModalComponentSelect('HedgeToSignalCovert', signalRequest)}>Convert Hedge As Signal</button> 

                      {(signalRequest.repelTrade === 'true' || signalRequest.repelTrade === 'lateRepel') && (
                        <button onClick={() => handleModalComponentSelect('RepelTradeHedgeCloser', signalRequest)}>
                          RepelTrade Hedge Closer
                        </button>
                      )} 
                      </div>
                    <br/>
                    <br/>
                    <h2 className="page-title">Hedge Offset Levels</h2>
                    <HedgeOffsetLevelDetails
                      signalRequestId={signalRequest.signalRequestId}
                      refreshTrigger={refreshTrigger}
                    />  
                    <br/>
                    <br/>
                    <h2 className="page-title">Special Configuration</h2>
                    <SpecialConfigurationDetails
                      signalRequestId={signalRequest.signalRequestId}
                      refreshTrigger={refreshTrigger}
                    />         
                    <br/>            
                     </div>

                ))):(
                        <p>{symbol ? `No active positions found for ${symbol}` : "No active positions found"}</p>
                  )}
                </div>
              )}
              
              {isManualHedgeModalOpen && (
                <ManualHedge
                  isOpen={isManualHedgeModalOpen}
                  closeModal={closeManualHedgeModal}
                  symbolData={actionSymbol}
                />
              )}        

              {isSignalDCAModalOpen && (
                <SignalDCA
                  isOpen={isSignalDCAModalOpen}
                  closeModal={closeSignalDCAModal}
                  symbolData={actionSymbol}
                />
              )}   

              {isSignalTPModalOpen && (
                <SignalPartialTakeProfit
                  isOpen={isSignalTPModalOpen}
                  closeModal={closeSignalTPModal}
                  symbolData={actionSymbol}
                />
              )} 

              {isHedgeTPModalOpen && (
                <HedgePartialTakeProfit
                  isOpen={isHedgeTPModalOpen}
                  closeModal={closeHedgeTPModal}
                  symbolData={actionSymbol}
                />
              )} 

              {isRepelTradeHedgeCloserModalOpen && (
                <RepelTradeHedgeCloserModal
                  isOpen={isRepelTradeHedgeCloserModalOpen}
                  closeModal={closeRepelTradeHedgeCloserModal}
                  symbolData={actionSymbol}
                />
              )} 

              {isHedgeToSignalConvertModalOpen && (
                <HedgeToSignalConversionModal
                  isOpen={isHedgeToSignalConvertModalOpen}
                  closeModal={closeHedgeToSignalConvertModal}
                  symbolData={actionSymbol}
                />
              )} 

              {isSignalResistanceLevelModalOpen && (
                <SignalResistanceLevel
                  isOpen={isSignalResistanceLevelModalOpen}
                  closeModal={closeSignalResistanceLevelModal}
                  symbolData={actionSymbol}
                />
              )}

                {isHedgeResistanceLevelModalOpen && (
                <HedgeResistanceLevel
                  isOpen={isHedgeResistanceLevelModalOpen}
                  closeModal={closeHedgeResistanceLevelModal}
                  symbolData={actionSymbol}
                />
              )}   

            <br />
            
      </div>

  );
}

export default PositionDetails;
